import {faPenToSquare} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Flex, Typography} from 'antd';
import {isNumber} from 'lodash';
import {ReactElement, useState} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {gray7} from '../../../../../../../../css/var-export.scss';
import {RatingStarLine} from '../../../../../../../../layout/rating-star-line/rating-star-line';
import {Locale} from '../../../../../../../../provider/locale/localization';
import {ReviewHistoryDataType} from '../../../../../../../../service/reviews/reviews-history';
import {PreviewGroup} from '../../preview-group/preview-group';
import {constructCommentPreview, extractReviewCommentContent} from '../../review-helper';

import * as styles from './history-modal.scss';

type PropsType = {
    log: {source: 'history'; loggedAt: string} & ReviewHistoryDataType;
    formattedDate: string | null;
    formattedTime: string | null;
};

export function HistoryLog(props: PropsType): ReactElement {
    const {log, formattedTime, formattedDate} = props;

    const [expanded, setExpanded] = useState<boolean>(false);
    const [expandedOldValue, setExpandedOldValue] = useState<boolean>(false);

    return (
        <Flex gap={8} key={log.date} vertical>
            <Text secondary>
                {formattedDate} {formattedTime}
            </Text>
            <Flex>
                <FontAwesomeIcon color={gray7} fontSize={16} icon={faPenToSquare} />
                <Text lighter stringKey="REVIEWS__REVIEW_CHANGE_HISTORY__ON_CATALOG" />
            </Flex>
            <Flex vertical>
                <Text bolder stringKey="REVIEWS__REVIEW_CHANGE_HISTORY__BEFORE" />

                {isNumber(Number(log.old_value)) && (
                    <>
                        <Text stringKey="REVIEWS__REVIEW_CHANGE_HISTORY__RATING" />
                        <RatingStarLine rating={Number(log.old_value)} />
                    </>
                )}

                <Flex vertical>
                    <Typography.Paragraph
                        ellipsis={{
                            rows: 3,
                            expandable: 'collapsible',
                            expanded: expandedOldValue,
                            onExpand: (_data, info) => setExpandedOldValue(info.expanded),
                            symbol: (
                                <Locale
                                    stringKey={
                                        expanded
                                            ? 'REVIEWS__REVIEW_ABUSE__HIDE_TEXT'
                                            : 'REVIEWS__REVIEW_ABUSE__SHOW_TEXT'
                                    }
                                />
                            ),
                        }}
                    >
                        {constructCommentPreview(log.old_value)}
                    </Typography.Paragraph>
                    <PreviewGroup
                        imageClassName={styles.HistoryModal_previewImage}
                        images={extractReviewCommentContent(log.old_value)?.images}
                        videos={extractReviewCommentContent(log.old_value)?.videos}
                    />
                </Flex>
            </Flex>

            <Flex vertical>
                <Text bolder stringKey="REVIEWS__REVIEW_CHANGE_HISTORY__AFTER" />

                {isNumber(Number(log.new_value)) && (
                    <>
                        <span>
                            <Locale stringKey="REVIEWS__REVIEW_CHANGE_HISTORY__RATING" />
                        </span>

                        <RatingStarLine rating={Number(log.new_value)} />
                    </>
                )}

                <Flex vertical>
                    <Typography.Paragraph
                        ellipsis={{
                            rows: 3,
                            expandable: 'collapsible',
                            expanded,
                            onExpand: (_data, info) => setExpanded(info.expanded),
                            symbol: (
                                <Locale
                                    stringKey={
                                        expanded
                                            ? 'REVIEWS__REVIEW_ABUSE__HIDE_TEXT'
                                            : 'REVIEWS__REVIEW_ABUSE__SHOW_TEXT'
                                    }
                                />
                            ),
                        }}
                    >
                        {constructCommentPreview(log.new_value)}
                    </Typography.Paragraph>

                    <PreviewGroup
                        imageClassName={styles.HistoryModal_previewImage}
                        images={extractReviewCommentContent(log.new_value)?.images}
                        videos={extractReviewCommentContent(log.new_value)?.videos}
                    />
                </Flex>
            </Flex>
        </Flex>
    );
}
